import React from "react";
import "./DetailsInputTable.css";
import Counties from "../../../config/CountiesConfig";
import AppConfig from "../../../config/AppConfig";

import fuelLightImg from "../../../assets/fuel_light.JPG";
import fuelMediumImg from "../../../assets/fuel_medium.JPG";
import fuelHeavyImg from "../../../assets/fuel_heavy.JPG";
import moment from "moment-timezone";

export class DetailsInputTable extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            form: this.props.form,
        }
    }

    _renderFuelSelector(){

        const fuelOptions = [
            {
                id: AppConfig.fuel.light,
                img: fuelLightImg,
                label: this.props.i18n.Input_Fuel_Load_Light
            },
            {
                id: AppConfig.fuel.medium,
                img: fuelMediumImg,
                label: this.props.i18n.Input_Fuel_Load_Medium
            },
            {
                id: AppConfig.fuel.heavy,
                img: fuelHeavyImg,
                label: this.props.i18n.Input_Fuel_Load_Heavy
            }
        ]

        return (
            <div className="image-button-group">
                {fuelOptions.map(option => (
                    <button
                        key={option.id}
                        className={`image-button ${
                            this.state.form.fuel === option.id ? "selected" : ""
                        }`}
                        onClick={() =>
                            this.setState(prev => ({form: {...prev.form, fuel: option.id}}))
                        }

                    >
                        <div className="image-tooltip">
                            <img src={option.img} alt={option.label} />
                            <div className="image-tooltip-preview">
                                <img src={option.img} alt={option.label} />
                                <span>{option.label + " " + this.props.i18n.Input_Header_Fuel}</span>
                            </div>
                        </div>

                        <span>{option.label}</span>
                    </button>
                ))}
            </div>
        );
    }

    _renderCountySelector(){
        return(
            <select
                value={this.state.form.county.id}
                onChange={(e) =>
                    this.setState(prev => ({
                        form: { ...prev.form, county: Counties.find(county => county.id === Number(e.target.value)) }
                    }))
                }
            >
                {Counties.map(option => (
                    <option key={option.id} value={option.id}>
                        {option.displayName}
                    </option>
                ))}

            </select>
        )
    }

    _renderSizeSelector(){

        const sizeOptions = [
            {
                id: AppConfig.size.small,
                label: this.props.i18n.Input_Size_Small
            },
            {
                id: AppConfig.size.medium,
                label: this.props.i18n.Input_Size_Medium
            },
            {
                id: AppConfig.size.large,
                label: this.props.i18n.Input_Size_Large
            },
        ]

        return(
            <select
                value={this.state.form.size}
                onChange={(e) =>
                    this.setState(prev => ({
                        form: { ...prev.form, size: e.target.value }
                    }))
                }
            >
                {sizeOptions.map(option => (
                    <option key={option.id} value={option.id}>
                        {option.label}
                    </option>
                ))}

            </select>
        )
    }

    _renderDateSelector() {
        return (
            <input
                type="date"
                className="details-date-input"
                value={this.state.form.cst.format("YYYY-MM-DD")}
                onChange={(e) => {
                    const cstDate = moment
                        .tz(e.target.value, "YYYY-MM-DD", AppConfig.time.displayTimezone)
                        .hour(10);
                    this.setState(prev => ({
                        form: { ...prev.form, cst: cstDate }
                    }));
                }}
            />
        );
    }

    _renderSubmitButton(){
        return(
            <button
                className="details-submit-button"
                onClick={() => this.props.formSubmitCallback(this.state.form)}
                type="button"
            >
                {this.props.i18n.Input_Submit}
            </button>
        )
    }


    render() {


        return (
            <table className="details-table" cellPadding="0" cellSpacing="0">

                <thead className="details-table-head">
                    <tr>
                        <th  className={"details-header-column"}>
                            {this.props.i18n.Input_Header_Fuel}
                        </th>
                        <th  className={"details-header-column"}>
                            {this.props.i18n.Input_Header_County}
                        </th>
                        <th  className={"details-header-column"}>
                            {this.props.i18n.Input_Header_Size}
                        </th>
                        <th  className={"details-header-column"}>
                            {this.props.i18n.Input_Header_Date}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th className={"details-inner-column inner-padding"}>
                            <div className={"details-selector"}>
                                {this._renderFuelSelector()}
                            </div>
                        </th>
                        <th className={"details-inner-column inner-padding"}>
                            {this._renderCountySelector()}
                        </th>
                        <th className={"details-inner-column inner-padding"}>
                            {this._renderSizeSelector()}
                        </th>
                        <th className={"details-inner-column inner-padding"}>
                            {this._renderDateSelector()}
                        </th>
                    </tr>

                <tr>
                    <th className={"details-inner-column inner-padding-no-top"} colSpan={4}>
                        {this._renderSubmitButton()}
                    </th>
                </tr>

                </tbody>

            </table>

        );
    }
}
